import React from "react";
import useNearViewport from "../../hooks/useNearViewport";
import "./ProductSections.css";
import type { Product } from "../../data/products";

interface ProductSectionsProps {
  product: Product;
}

const ProductSections: React.FC<ProductSectionsProps> = ({ product }) => {
  const { ref, isNear } = useNearViewport<HTMLDivElement>();
  const hasClosetsImage = product.closetsSectionImage != null;

  return (
    <div className="pg-product-hero">
      <div className="pg-frame-108">
        {/* Bottom Section: Closets - only shown when product has closetsSectionImage */}
        {hasClosetsImage && (
          <div
            ref={ref}
            className="pg-frame-150 pg-rectangle pg-rectangle--bg"
            style={{
              backgroundImage: isNear ? `url(${product.closetsSectionImage})` : "none",
              height: "665px",
            }}
          >
           
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductSections;
